export default (state, action) => {
  return Object.assign({}, state, {
    request: {},
    address: {},
    loading: false,
    status: action.status
  });
};
